import { downloadEducationPlanAttachment } from '../../../api/education';
import {
  EducationAnnualPlan,
  educationPlanTypeLabel,
  parseEducationPlanItems,
} from '../../../types/education';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: EducationAnnualPlan;
}

function normalizeStatus(status?: string | null) {
  const s = (status || 'DRAFT').toUpperCase();
  if (s === 'COMPLETED' || s === 'SUBMITTED') return 'CONFIRMED';
  return s;
}

function statusLabel(status?: string | null, approvalInProgress?: boolean | null) {
  if (approvalInProgress) return '결재 요청 중';
  const s = normalizeStatus(status);
  if (s === 'APPROVED') return '승인';
  if (s === 'CONFIRMED') return '승인';
  return '작성중';
}

function statusBadgeClass(status?: string | null, approvalInProgress?: boolean | null) {
  if (approvalInProgress) return 'pending';
  return normalizeStatus(status).toLowerCase();
}

function EducationPlanPreviewView({ detail }: Props) {
  const planItems = parseEducationPlanItems(detail.itemsJson);

  return (
    <div className="edu-plan-form">
      <div className="edu-plan-form__header">
        <div>
          <h3>연간 교육 계획서</h3>
          <p>{statusLabel(detail.status, detail.approvalInProgress)}</p>
        </div>
        <ApprovalStampBox
          authorName={detail.authorName}
          reviewerName={detail.reviewerName}
          approverName={detail.approverName}
        />
      </div>

      <section className="edu-plan-card">
        <div className="edu-plan-card__title">
          <div>
            <h4>문서 정보</h4>
          </div>
          <span
            className={`quality-badge is-${statusBadgeClass(detail.status, detail.approvalInProgress)}`}
          >
            {statusLabel(detail.status, detail.approvalInProgress)}
          </span>
        </div>
        <div className="edu-plan-grid">
          <label>
            문서번호
            <input value={detail.planNo || ''} disabled />
          </label>
          <label>
            연도
            <input type="number" value={detail.planYear || ''} disabled />
          </label>
          <label className="is-span-2">
            제목
            <input value={detail.title || ''} disabled />
          </label>
        </div>
      </section>

      <section className="edu-plan-card">
        <div className="edu-plan-card__title">
          <div>
            <h4>교육 계획 항목</h4>
            <p className="edu-plan-card__sub">{planItems.length}건</p>
          </div>
        </div>
        <div className="edu-plan-table-wrap">
          <table className="edu-plan-table">
            <thead>
              <tr>
                <th className="col-no">No</th>
                <th className="col-type">구분</th>
                <th className="col-course">교육과정명</th>
                <th className="col-detail">세부교육내용</th>
                <th className="col-target">대상</th>
                <th className="col-period">시기</th>
                <th className="col-hours">시간</th>
                <th className="col-method">방법</th>
                <th className="col-owner">담당</th>
              </tr>
            </thead>
            <tbody>
              {planItems.map((item, index) => (
                <tr key={item.id}>
                  <td className="is-center col-no">{index + 1}</td>
                  <td className="is-center col-type">
                    <span
                      className={
                        item.educationType === 'EXTERNAL'
                          ? 'edu-plan-type is-external'
                          : 'edu-plan-type is-internal'
                      }
                    >
                      {educationPlanTypeLabel(item.educationType) || '-'}
                    </span>
                  </td>
                  <td className="col-course">
                    <input value={item.courseName} disabled />
                  </td>
                  <td className="col-detail">
                    <input value={item.detailContent} disabled />
                  </td>
                  <td className="col-target">
                    <input value={item.target} disabled />
                  </td>
                  <td className="col-period">
                    <input value={item.period} disabled />
                  </td>
                  <td className="col-hours">
                    <input value={item.hours} disabled />
                  </td>
                  <td className="col-method">
                    <input value={item.method} disabled />
                  </td>
                  <td className="col-owner">
                    <input value={item.owner} disabled />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="edu-plan-card">
        <div className="edu-plan-card__title">
          <div>
            <h4>첨부파일</h4>
          </div>
        </div>
        <p className="edu-plan-hint">교육 계획 근거 문서, 승인본 PDF 등을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadEducationPlanAttachment(detail.planId, file.attachmentId, file.fileName);
          }}
        />
      </section>
    </div>
  );
}

export default EducationPlanPreviewView;
